import * as React from "react";

const SvgArrowForward = ({ color, size }) => (
  <svg
    viewBox="0 0 24 25"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12 4.5-1.41 1.41 5.58 5.59H4v2h12.17l-5.58 5.59L12 20.5l8-8-8-8z"
      fill={color}
    />
  </svg>
);

export default SvgArrowForward;
